import { Link } from "react-router-dom";
import { Monitor, Clapperboard, Check, MessageCircle } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/motion";
import { FinalCTA } from "../sections/HomeBlocks2";
import { ProcessSection } from "../sections/HomeBlocks";
import { BUSINESS, IMG } from "../data/content";

const SERVICES = [
  {
    id: "web", icon: Monitor, title: "Website Design", img: IMG.web2, chapter: "01",
    lead: "Custom websites designed to sell — not just to look good.",
    points: [
      "Landing pages, business sites and storefront designs",
      "Fully responsive across desktop, tablet and mobile",
      "Conversion-focused layout, copy structure and CTAs",
      "Built and delivered entirely remotely, with previews in WhatsApp",
      "Clean handover — the site and its files are yours",
    ],
  },
  {
    id: "video", icon: Clapperboard, title: "Video Ad Creation", img: IMG.video3, chapter: "02",
    lead: "Short, scroll-stopping ads made for the platforms your customers actually use.",
    points: [
      "Ad videos for social feeds, stories and campaigns",
      "Concept, script structure, editing and color grade",
      "Formats sized for each platform (vertical, square, wide)",
      "Brand-consistent motion, type and sound choices",
      "Revisions handled fast, straight in the chat",
    ],
  },
];

export default function Services() {
  return (
    <main>
      <PageHeader
       
        lines={["Two crafts,", "one studio."]}
        sub="Website design and video ad creation — handled by the same team, so your brand looks and moves the same everywhere."
      />
      {SERVICES.map((s, idx) => (
        <section key={s.id} id={s.id} className={`py-20 ${idx % 2 ? "bg-[#1B1D33]/40 border-y border-[rgba(255,255,255,0.05)]" : ""}`} data-testid={`service-detail-${s.id}`}>
          <div className={`container-x grid lg:grid-cols-2 gap-14 items-center`}>
            <Reveal className={idx % 2 ? "lg:order-2" : ""}>
              <div className="rounded-2xl overflow-hidden border border-[rgba(255,255,255,0.08)]">
                <img src={s.img} alt={`${s.title} example work by BHF Creative`} loading="lazy" className="w-full object-cover" />
              </div>
            </Reveal>
            <Reveal delay={0.15} className={idx % 2 ? "lg:order-1" : ""}>
              <p className="eyebrow mb-3">{s.chapter} — Service</p>
              <s.icon size={30} className="text-[#6C5CE7] mb-4" />
              <h2>{s.title}</h2>
              <p className="text-[#A0A3C2] mt-4 leading-relaxed">{s.lead}</p>
              <ul className="mt-7 space-y-3 p-0 list-none">
                {s.points.map((p) => (
                  <li key={p} className="flex items-start gap-3 text-[0.95rem]">
                    <Check size={17} className="text-[#00D9C0] mt-0.5 shrink-0" /> <span className="text-[#F5F5FA]/90">{p}</span>
                  </li>
                ))}
              </ul>
              <div className="flex flex-wrap gap-4 mt-9">
                <a href={BUSINESS.whatsapp} target="_blank" rel="noopener noreferrer" data-testid={`service-${s.id}-whatsapp-btn`} className="btn btn-wa no-underline">
                  <MessageCircle size={17} /> Discuss your project
                </a>
                <Link to="/contact" data-testid={`service-${s.id}-quote-btn`} className="btn btn-ghost no-underline">Request a quote</Link>
              </div>
            </Reveal>
          </div>
        </section>
      ))}
      <ProcessSection chapter="03" />
      <FinalCTA />
    </main>
  );
}
